import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { ReferralsAccessLayout } from 'pages/settings/pages/referrals/layout/ReferralsAccessLayout'
import { ReferralsPageLayout } from 'pages/settings/pages/referrals/layout/ReferralsPageLayout'
import { ReferralsViewPage } from 'pages/settings/pages/referrals/pages'

export const ReferralsRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route element={<ReferralsAccessLayout />}>
        <Route element={<ReferralsPageLayout />}>
          <Route path={'/'} element={<ReferralsViewPage />} />
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
})
